import { ScopeCalculationObjectType } from '../schema/ScopeCalculationObjectType';

export const isRecurringItem = ({
    Recurrence,
    CalendarItemType,
    IsRecurring,
    RecurrenceId,
}: ScopeCalculationObjectType = {}): boolean =>
    IsRecurring ||
    !!Recurrence ||
    !!(CalendarItemType === 'Single' && RecurrenceId) ||
    !!(CalendarItemType && CalendarItemType !== 'Single');
